import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // Changed from true to false
    threshold: 0.2, // Increased threshold for better timing
    rootMargin: '-50px 0px', // Added margin for better trigger timing
  });

  return (
    <motion.section
      id="about"
      className="section"
      ref={ref}
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h2
        className="section-title"
        initial={{ y: 50, opacity: 0 }}
        animate={inView ? { y: 0, opacity: 1 } : { y: 50, opacity: 0 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        About Me
      </motion.h2>

      <div className="about-content">
        <motion.div
          className="about-text"
          initial={{ x: -100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <p>
            Hey! I am a passionate Full Stack Developer and AI/ML enthusiast currently pursuing my degree at IIT Madras with coursework wrapping up by the end of 2026 and official graduation in 2027. My tech journey began with a simple but powerful question: “How does this stuff actually work?” That curiosity pulled me deep into the world of Artificial Intelligence and Machine Learning. It’s really amazing how smart algorithms can tackle complex, real life problems and come up with clever solutions.

            What I love most is being involved in the whole process from crafting sleek and user friendly interfaces to building solid backends that scale all the way to integrating intelligent features that make people wonder, “How did it know that?” Building end-to-end solutions that mix the best of AI with apps. Whether it’s coding, machine learning models, creating responsive frontends, or designing efficient backend systems, I am all about making tech that actually solves problems. I like exploring new frameworks, diving into open-source and learning whatever’s new in tech. I believe the best devs are those who never stop asking questions and pushing limits.

            I am always up for collaborating with fellow developers and innovators. Got a tricky problem or an exciting idea? Let’s connect and make something awesome. Ready to build the future - one algorithm at a time?
          </p>
          <p>

          </p>
          <p>

          </p>
        </motion.div>

        <motion.div
          className="about-image"
          initial={{ x: 100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : { x: 100, opacity: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <div className="profile-card">
            <div className="profile-info">
              <h3>Quick Facts</h3>
              <div className="fact-item">
                <span className="fact-icon">🎓</span>
                <span><strong>Institution:</strong> IIT Madras</span>
              </div>
              <div className="fact-item">
                <span className="fact-icon">📅</span>
                <span><strong>Graduation:</strong> 2027</span>
              </div>
              <div className="fact-item">
                <span className="fact-icon">🔬</span>
                <span><strong>Focus:</strong> AI/ML | Full Stack | SE</span>
              </div>
              <div className="fact-item">
                <span className="fact-icon">🌟</span>
                <span><strong>Transition:</strong> Next Month</span>
              </div>
              <div className="fact-item">
                <span className="fact-icon">💡</span>
                <span><strong>Passion:</strong> Innovation & Problem Solving</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default About;
